import React from "react";
import { SearchInput } from "react-admin";

const ClassFilters = [<SearchInput source="q" alwaysOn />];

export default ClassFilters;
